module.exports = __webpack_public_path__ + "img/DSC06738.f99fe100.jpg";